import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {generatePath} from '@github-ui/react-router'
import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {ChangesRoutePayload} from './route-payload-types'

export function buildPullRequestsChangesRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsChangesRoute', {
    path: '/:owner/:repo/pull/:pr_number/changes',
    queries: [mainQuery<ChangesRoutePayload>()],
  })
}

export const pullRequestsChangesRoute = buildPullRequestsChangesRoute(pullRequestsAppBuilder)

export function buildPullRequestsChangesWithRangeRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsChangesWithRangeRoute', {
    path: '/:owner/:repo/pull/:pr_number/changes/:range',
    queries: [mainQuery<ChangesRoutePayload>()],
  })
}

export const pullRequestsChangesWithRangeRoute = buildPullRequestsChangesWithRangeRoute(pullRequestsAppBuilder)

export const FILE_METADATA_PATH = '/:owner/:repo/pull/:pr_number/file_metadata/:baseSha/:headSha'

export function fileMetadataPath(params: {
  owner: string
  repo: string
  pr_number: string
  baseSha: string
  headSha: string
}) {
  return generatePath(FILE_METADATA_PATH, params)
}
